




































































































































import DateMixin from "@/mixins/DateMixin";
import { ReportsModule } from "@/store/reports.module";
import { RequestsModule } from "@/store/requests.module";
import { translate } from "@/utils";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import { RequestC } from "~/modules/request";
import InfoQuestionary from "@/components/ui/InfoQuestionary.vue";
import { QuestionareModule } from "@/store/questionary.module";
import { AuthModule } from "@/store/auth.module";
import { Questionnaire } from "~/services/questionare";
import { FileService } from "@/services/file.service";

@Component({
  components: {
    InfoQuestionary,
  },
})
export default class RequestsView extends mixins(DateMixin) {
  dialog: boolean = false;
  dialogText: string = null as any;
  deleted: RequestC = null as any;
  loading: boolean = false;

  get showQuestionareInfo() {
    return QuestionareModule.questionsList.length > 0;
  }

  getColor(item: RequestC) {
    switch (item.code_name) {
      case "state_draft":
        return "#8E8E8E";
      case "state_considering":
        return "#FDA700";
      case "state_returned":
        return "#FDD400";
      case "state_approval":
        return "#00B61D";
      default:
        break;
    }
  }

  async deleteReq() {
    try {
      this.loading = true;
      await RequestsModule.deleteRequest(this.deleted.record_id);
      await RequestsModule.getRequestList();
      this.dialog = false;
    } finally {
      this.loading = false;
    }
  }

  async downloadFile(reqNumber: number) {
    try {
      this.loading = true;
      const { pdf_data } = await RequestsModule.downloadPDF(reqNumber);

      const byteOffset = 0;
      const blob = new Blob([new Uint8Array(pdf_data.data, byteOffset)], {
        type: "application/pdf",
      });
      FileService.openPdfInNewTab(blob);
    } finally {
      this.loading = false;
    }
  }

  async downloadCMS(reqNumber: number) {
    try {
      this.loading = true;
      const { pdf_data } = await RequestsModule.downloadPDF(reqNumber);

      const byteOffset = 0;
      const blob = new Blob([new Uint8Array(pdf_data.data, byteOffset)]);
      await FileService.downloadFile(blob, "print-form.pdf.cms");
    } finally {
      this.loading = false;
    }
  }

  showDeleteDialog(item: RequestC) {
    this.deleted = item;
    this.dialogText = this.$t("list.delete", {
      date: this.formatDate(item.request_date),
    }).toString();
    this.dialog = true;
  }

  get getReqList() {
    const items = translate(RequestsModule.list);
    return items;
  }

  async created() {
    await RequestsModule.getRequestList();
    if (AuthModule.user && AuthModule.user.record_id)
      await QuestionareModule.getQuestionnaire();
    QuestionareModule.questionsList.forEach((element: Questionnaire) => {
      element.rqd.forEach(r => {
        r.checked = null as any;
        r.text = null as any;
      });
    });
  }

  async clickReqNum(RID: number) {
    this.$router.push(`/edit/${RID}`);
  }

  async showReqPdf(iRequestId: number, path: string) {
    await ReportsModule.generateReport({
      action: "open",
      path: path,
      type: "pdf",
      filename: "filename",
      query: {
        iRequestId: iRequestId,
      },
    });
  }
}
